import { Box, Text } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { DataList } from '@tiendanube/components';
import { Stack } from 'commons/components';

function OrderMerchantChargesInProgressRow(): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS, {
    keyPrefix: 'orderSummaryCard.tableAmounts',
  });

  return (
    <DataList.Row id="merchant_charge_in_progress">
      <DataList.Cell width={70}>
        <Stack spacing="tight">
          <Text color="neutral-textHigh">{t('charges')}</Text>
        </Stack>
      </DataList.Cell>
      <DataList.Cell width={30} alignRight>
        <Box display="block">
          <Text textAlign="right" color="neutral-textHigh">
            {t('merchantChargesInProgress')}
          </Text>
        </Box>
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderMerchantChargesInProgressRow;
